/*
    Autohandler for making an element editable after its trigger has been clicked.
    Too be used w/ the .sw-hover and .sw-hover--show css classes
 */

var $ = require('./../sw-jquery');

$(function() {

    //when the trigger has been clicked set the target to editable and focus it, then hide the trigger
    $('body').on('click', '[data-sw-content-editable-trigger]', function() {
        $('[data-sw-content-editable-target]').attr("contenteditable", "true").focus();
    });

    $('body').on('focusout', '[data-sw-content-editable-target]', function(e){
        $(e.currentTarget).attr("contenteditable", "false");
    });

});
